<template>
  <MainHeader header__white="header__white" />
  <Breadcrumb :title="post.title" :subtitle="post.title" />
  <section class="blog-details__area pt-120 pb-120">
      <div class="container">
         <div class="row">
            <div class="col-xxl-10 offset-xxl-1">
               <div class="blog-details__wrapper">
                  <div class="blog-details__img mb-45">
                     <img :src="post.image" :alt="post.title">
                  </div>
                  <div class="blog-details__content">
                     <h1 class="blog-details__title">{{ post.title }}</h1>
                     <div class="blog-details__text" v-html="formattedContent"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </section>
  <Footer footerPadding="true" />
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { jsonService } from '@/services/jsonService'
import MainHeader from '../components/Home/Header.vue'
import Footer from '../components/Home/Footer.vue'
import Breadcrumb from '../components/common/Breadcrumb.vue'

export default {
  name: "BlogDetails",
  components: {
    MainHeader,
    Footer,
    Breadcrumb
  },
  setup() {
    const route = useRoute()
    const post = ref({})

    const createSlug = (text) => {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[ğ]/g, 'g')
        .replace(/[ü]/g, 'u')
        .replace(/[ş]/g, 's')
        .replace(/[ı]/g, 'i')
        .replace(/[ö]/g, 'o')
        .replace(/[ç]/g, 'c')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
    }

    const formattedContent = computed(() => {
      if (!post.value.content) return ''
      return post.value.content.replace(/\n/g, '<br>')
    })

    const loadPost = async () => {
      const posts = await jsonService.getBlogPosts()
      const foundPost = posts.find(p => createSlug(p.title) === route.params.slug)
      if (foundPost) {
        post.value = foundPost
      }
    }

    onMounted(() => {
      loadPost()
    })

    return {
      post,
      formattedContent
    }
  }
}
</script>

<style scoped>
.page__title-2 {
    font-size: 40px;
    color: #fff;
    line-height: 1.1;
    margin-bottom: 20px;
}

.blog-details__img {
    border-radius: 10px;
    overflow: hidden;
    margin-top: -100px;
    position: relative;
    z-index: 1;
}

.blog-details__img img {
    width: 100%;
    height: auto;
}

.blog-details__title {
    font-size: 32px;
    font-weight: 700;
    color: #0e1133;
    margin-bottom: 30px;
}

.blog-details__text {
    color: #666;
    font-size: 16px;
    line-height: 1.8;
}

.blog-details__text :deep(p) {
    margin-bottom: 15px;
}

.blog-details__wrapper {
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}
</style>
